import { motion, useReducedMotion } from "framer-motion";

export function PageHero({ kicker, title, text, image }) {
  const reduce = useReducedMotion();
  return (
    <section className="relative overflow-hidden bg-ink text-white" data-testid="page-hero">
      <div className="tech-grid-dark absolute inset-0" />
      {image && (
        <>
          <img src={image} alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover opacity-20" />
          <div className="absolute inset-0 bg-ink/70" />
        </>
      )}
      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 py-20 lg:py-28">
        <motion.span initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.1 }}
          className="flex items-center gap-2 font-body text-xs font-semibold uppercase tracking-[0.28em] text-amber">
          <span className="w-8 h-px bg-amber" /> {kicker}
        </motion.span>
        <motion.h1 initial={reduce ? { opacity: 0 } : { opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="mt-5 max-w-4xl font-display font-bold uppercase leading-[0.92] tracking-tight text-[clamp(38px,5.5vw,72px)]">
          {title}
        </motion.h1>
        {text && (
          <motion.p initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.2, duration: 0.6 }}
            className="mt-6 max-w-2xl text-[clamp(16px,2vw,18px)] leading-relaxed text-white/70">{text}</motion.p>
        )}
      </div>
    </section>
  );
}
